<div
  class="resize-handler"
  (mousedown)="onMouseDown($event)"
  [class.resizing]="isResizing"
>
  <div class="resize-line"></div>
</div>
